var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 106,
    viewBox: "0 0 103 106",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.713 25C41.66 25 40 23.698 40 22.092v-2.18C40 18.302 41.66 17 43.713 17H58.29c2.05 0 3.71 1.302 3.71 2.912v2.18C62 23.698 60.34 25 58.29 25H43.713z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.776 16c-2.315 0-3.771-1.117-4.418-2.36l-4.327-9.794C33.732 1.391 35.616 0 37.931 0c0 0 9.474 1.33 12.712 1.33C53.876 1.33 63.067 0 63.067 0c2.315 0 4.255 1.73 3.888 3.66l-4.02 9.235C61.853 15.103 60.62 16 58.305 16h-15.53z",
    fill: "#B0AFB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.845 26.126C22.715 27.858 2.262 47.982.182 73.046-.65 83.072 1.405 92.555 5.6 100.764c1.65 3.235 5.023 5.237 8.658 5.237h74.484c3.613 0 6.978-1.964 8.624-5.172A51.112 51.112 0 0 0 103 77.431c0-29.612-25.06-53.379-55.155-51.305",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B0AFB1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.146 55h-3.005c-1.022 0-1.854.781-1.854 1.737v18.441c0 .486-.226.683-.775.683H52.6c-.541 0-.977-.41-.977-.918v-8.8c0-.96-.832-1.74-1.854-1.74h-2.565c-1.022 0-1.854.78-1.854 1.74v14.463c0 .956.832 1.737 1.854 1.737h17.351c3.102 0 5.445-2.219 5.445-5.158V56.737c0-.956-.832-1.737-1.854-1.737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.425 64.013v8.277c0 1.012.832 1.833 1.85 1.833h2.52c1.023 0 1.855-.82 1.855-1.833V61.844c0-3.774-3.102-6.844-6.912-6.844H40.4C37.971 55 36 56.957 36 59.362v22.801c0 1.013.828 1.837 1.85 1.837h3.054a1.848 1.848 0 0 0 1.854-1.837V62.808a.97.97 0 0 1 .974-.964h8.5c1.211 0 2.193.972 2.193 2.169"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.998bb6a07d0c5142e9bd97f63896475d.svg";
export { ForwardRef as ReactComponent };